module.exports = __webpack_public_path__ + "media/customizations/serenbe/back-12cb69fb07022e4fb63505f82c967d81.jpg";